import moment from 'moment';
import StateLoader from './StateLoader';
import { SELECT_LANGUAGE } from '../site-render/src/redux/language';

const stateLoader = new StateLoader('language');

// Initial state
const initialState = stateLoader.loadState(
  (typeof window !== 'undefined' && window.__LANGUAGE__) || process.env.REACT_APP_LANGUAGE,
);

if (initialState) {
  moment.locale(initialState);
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  let newState;
  switch (action.type) {
    case SELECT_LANGUAGE:
      newState = action.payload;
      moment.locale(newState);
      break;
    default:
      newState = state;
  }

  if (newState !== state) {
    stateLoader.saveState(newState);
  }

  return newState;
}

// Selectors
export function mapStateToProps({ language }) {
  return { language };
}



// WEBPACK FOOTER //
// ./src/redux/language.js